import * as React from 'react';

type PermissionContextType = {
  routePermission?: any[],
  pageElementPermission?: any[],
}

// Create the context
const PermissionContext = React.createContext<PermissionContextType>({
  routePermission: [],
  pageElementPermission: [],
});

export default PermissionContext;
